"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScoreTypeByAttempt = exports.ScoreType = void 0;
exports.getScoreTypes = getScoreTypes;
exports.getScoreTypeFrom = getScoreTypeFrom;
var attempt_status_enum_1 = require("./attempt-status.enum");
var assessment_status_enum_1 = require("./assessment-status.enum");
var ScoreType;
(function (ScoreType) {
    ScoreType["Scored"] = "scored";
    ScoreType["PartiallyScored"] = "partially_scored";
    ScoreType["NotScored"] = "not_scored";
})(ScoreType || (exports.ScoreType = ScoreType = {}));
function getScoreTypes() {
    return [ScoreType.Scored, ScoreType.PartiallyScored, ScoreType.NotScored];
}
function getScoreTypeFrom(value) {
    return getScoreTypes().find(function (type) { return type === value; });
}
var isPartiallyScoredForced = function (_a) {
    var responses = _a.responses;
    return responses.length > 1 &&
        responses.some(function (_a) {
            var attempted = _a.attempted;
            return !attempted;
        }) &&
        responses.some(function (_a) {
            var attempted = _a.attempted, isGraded = _a.isGraded;
            return attempted && !isGraded;
        });
};
var getAttemptStatus = function (attempt) {
    var assessmentTemplate = attempt.assessment.assessmentTemplate, isGraded = attempt.isGraded;
    var isPartiallyScored = (assessmentTemplate.hasBothManualAndAutoScored && !isGraded) ||
        isPartiallyScoredForced(attempt);
    switch (true) {
        case assessmentTemplate.hasBothManualAndAutoScored && isGraded:
            return ScoreType.Scored;
        case assessmentTemplate.isAllAutoScored:
        case isGraded:
            return ScoreType.Scored;
        case isPartiallyScored:
            return ScoreType.PartiallyScored;
        default:
            return ScoreType.NotScored;
    }
};
var getScoreTypeWhenStudentSubmitted = function (attempt) {
    var status = attempt.status;
    var attemptStatus;
    if (status === attempt_status_enum_1.AttemptStatus.Submitted || status === attempt_status_enum_1.AttemptStatus.Closed) {
        attemptStatus = getAttemptStatus(attempt);
    }
    else {
        attemptStatus = ScoreType.NotScored;
    }
    return attemptStatus;
};
var getScoreTypeWhenClassSubmitted = function (attempt) {
    var status = attempt.assessment.status;
    switch (true) {
        case status === assessment_status_enum_1.AssessmentStatus.Review:
        case status === assessment_status_enum_1.AssessmentStatus.Done:
        case status === assessment_status_enum_1.AssessmentStatus.NeedsGrading:
            return getAttemptStatus(attempt);
        default:
            return ScoreType.NotScored;
    }
};
var getScoreTypeWhenClassDone = function (status) {
    return status === assessment_status_enum_1.AssessmentStatus.Done ? ScoreType.Scored : ScoreType.NotScored;
};
var getScoreTypeByAttempt = function (attempt) {
    var _a = attempt.assessment, status = _a.status, scores = _a.settings.scores;
    var scoreType;
    if (scores && scores.showWhenStudentSubmitted) {
        scoreType = getScoreTypeWhenStudentSubmitted(attempt);
    }
    else if (scores && scores.showWhenClassSubmitted) {
        scoreType = getScoreTypeWhenClassSubmitted(attempt);
    }
    else {
        scoreType = getScoreTypeWhenClassDone(status);
    }
    return scoreType;
};
exports.getScoreTypeByAttempt = getScoreTypeByAttempt;
